import { graphic } from 'echarts/lib/echarts'

export function customBarRenderItem(params, api) {
  const categoryIndex = api.value(0)
  const start = api.coord([api.value(1), categoryIndex])
  const end = api.coord([api.value(2), categoryIndex])
  const height = api.size([0, 1])[1] * 0.4
  const rectShape = graphic.clipRectByRect(
    {
      x: start[0],
      y: start[1] - height / 2,
      width: end[0] - start[0],
      height: height,
    },
    {
      x: params.coordSys.x,
      y: params.coordSys.y,
      width: params.coordSys.width,
      height: params.coordSys.height,
    }
  )
  // console.log({ rectShape, style: api.style() })

  return (
    rectShape && {
      type: 'rect',
      shape: { ...rectShape, r: 4 },
      style: api.style(),
    }
  )
}
